/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * regel-personeel.ts
 * Gegenereerd met Junie (AI), 06-10-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Subclass voor personeel-regels.
 */

import { Filtertoolregel } from '../filtertool-regels';
import type { Planitem as PlanitemType } from '../../../models/planitem';
import type { Personeel as PersoneelType } from '../../../models/personeel';
import { PlanitemFilterbareRegel, PersoneelFilterbareRegel } from '../filtertool-capabilities';

/**
 * Personeelregel zonder extra velden.
 */
/**
 * Planitempersoneel-regel met een lijst van Personeel-id's. Geldig wanneer er ten minste 1 id is gekozen.
 */
export class FiltertoolPlanitempersoneelRegel extends Filtertoolregel implements PlanitemFilterbareRegel, PersoneelFilterbareRegel {
  /** Gekozen Personeel-id's. */
  personeelIds: number[];

  constructor(init?: Partial<Filtertoolregel> & { personeelIds?: number[] }) {
    super('planitempersoneel', init as any);
    this.personeelIds = Array.isArray(init?.personeelIds) ? init.personeelIds : [];
  }

  /**
   * Geldig wanneer er minstens één persoon is gekozen.
   */
  override get valid(): boolean {
    return this.personeelIds?.length > 0;
  }

  /**
   * Serialiseer inclusief personeelIds.
   */
  override toObject(): any {
    return { ...super.toObject(), personeelIds: this.personeelIds || [] };
  }

  /**
   * Past de personeelregel toe op een planitem op basis van gekoppelde personeelsleden.
   */
  public filterPlanitem(pi: PlanitemType): boolean {
    const ids = (pi.personeelids || []) as number[];
    return this.personeelIds.some(id => ids.includes(id));
  }

  /**
   * Past de personeelregel direct toe op een Personeel-object.
   * Matcht wanneer het id van het personeelslid voorkomt in de gekozen lijst.
   */
  public filterPersoneel(persoon: PersoneelType): boolean {
    const pid = persoon?.id;
    if (typeof pid !== 'number') {
      return false;
    }
    return this.personeelIds.includes(pid);
  }
}
